import { render, staticRenderFns } from "./total-enterprises.vue?vue&type=template&id=1a34b80b&"
import script from "./total-enterprises.vue?vue&type=script&lang=js&"
export * from "./total-enterprises.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports